module.exports = __webpack_public_path__ + "static/media/clapping_hands.33f6f0f6.gif";